<template>
  <div
    role="separator"
    class="base-divider"
    :class="computedClass"
    :style="styleComputed"
  />
</template>

<script setup lang="ts">
interface Props {
  color?: string
  height?: string
  vertical?: boolean
  type?: 'solid' | 'dashed'
  /** horizontal: max-width, vertical: max-height. По умолчанию 100% */
  maxSize?: string
}

const props = withDefaults(defineProps<Props>(), {
  color: 'var(--color-foreground-caption-300)',
  height: '1px',
  type: 'solid',
  maxSize: '100%',
})

const computedClass = computed(() => ({
  'base-divider--vertical': props.vertical,
  'base-divider--horizontal': !props.vertical,
  [`base-divider--type-${props.type}`]: props.type,
}))

const styleComputed = computed(() => ({
  '--divider-color': props.color,
  '--divider-thickness': props.height,
  '--divider-max-size': props.maxSize,
}))
</script>

<style lang="scss" scoped>
.base-divider {
  flex-shrink: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;

  // Горизонтальный: ширина 100%, ограничена max-size
  &--horizontal {
    width: 100%;
    max-width: var(--divider-max-size);
    height: var(--divider-thickness);

    &.base-divider--type-solid {
      background-color: var(--divider-color);
    }

    &.base-divider--type-dashed {
      background: none;
      border-bottom: var(--divider-thickness) dashed var(--divider-color);
    }
  }

  // Вертикальный: по центру, ограничен max-size
  &--vertical {
    width: var(--divider-thickness);
    min-height: var(--divider-max-size);
    max-height: var(--divider-max-size);
    align-self: center;

    &.base-divider--type-solid {
      background-color: var(--divider-color);
    }

    &.base-divider--type-dashed {
      background: none;
      border-left: var(--divider-thickness) dashed var(--divider-color);
    }
  }
}
</style>
